import React, { ReactElement } from "react";
import { connect, FormikContextType} from "formik";
import { AutorisatieNiveauState } from "../infra";
import AutorisatieNiveauGrid from "../infra/autorisatie-niveau-grid";

const Beheer = ({ formik: { values } }: { formik: FormikContextType<AutorisatieNiveauState> }): ReactElement => {
  return <AutorisatieNiveauGrid options={Object.keys(values.beheer)} formikKey={"beheer"} />;
};

export default connect<{}, AutorisatieNiveauState>(Beheer);
